import {
  Loader,
  If,
  Input,
  Accordion,
  Select
} from '@itau-loans-www/components'
import { cleanAccents } from '@itau-loans-www/utils'

import useDocumentForm from './hooks'

const DocumentForm = ({ control, formProps, isValid, initialValues }) => {
  const { statesOptions, agenciesOptions, loading } = useDocumentForm(
    formProps,
    initialValues
  )

  return (
    <If
      condition={!loading}
      renderIf={
        <Accordion title="Documento" initialOpen={!isValid}>
          <Input.Text
            label="RG"
            id="document_number"
            name="document_number"
            maxLength="14"
            autoComplete="on"
            control={control}
          />
          <Select
            label="Órgão expedidor"
            id="document_issuer"
            name="document_issuer"
            control={control}
            autocomplete="off"
            options={agenciesOptions}
            formProps={formProps}
            filterOptions={({ options, search }) =>
              options.filter((option) =>
                cleanAccents(option.label)
                  .toLowerCase()
                  .includes(cleanAccents(search).toLowerCase())
              )
            }
            onChange={(selectedOption) => {
              formProps.setValue('document_issuer_id', selectedOption.value)
            }}
          />
          <Select
            label="Estado"
            name="state"
            control={control}
            autocomplete="off"
            options={statesOptions}
            formProps={formProps}
            filterOptions={({ options, search }) =>
              options.filter((option) =>
                cleanAccents(option.label)
                  .toLowerCase()
                  .includes(cleanAccents(search).toLowerCase())
              )
            }
            onChange={(selectedOption) => {
              formProps.setValue('document_state_id', selectedOption.value)
              formProps.setValue('document_state', selectedOption.state_uf)
            }}
          />
          <Input.Birthdate
            autoComplete="on"
            control={control}
            id="document_issue_date"
            name="document_issue_date"
            label="Data de emissão"
          />
        </Accordion>
      }
      renderElse={<Loader visible hasOverlay />}
    />
  )
}

export default DocumentForm
